module.exports = __webpack_public_path__ + "img/smart-construction-section-1-img.1270251b.png";